import { GridLayoutGapSettings as KendoGridLayoutGapSettings } from "@progress/kendo-angular-layout";

export interface GridLayoutGapSettings extends KendoGridLayoutGapSettings {}